import { Tabs } from "antd-v5";
import React, { useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";

import { GenericIntegrationView, TabConfig } from "../GenericIntegration";
import SentinelOneLogsFileUpload from "./SentinelOneLogsFileUpload";
import SentinelOneLogsS3ConfigForm from "./SentinelOneLogsS3ConfigForm";
import {
  SENTINELONE_INTEGRATION_TYPE,
  SentinelOneS3Config,
} from "./sentinelOneLogsConstants";

interface SentinelOneLogsViewProps {
  onUpdateConfigComponent?: () => void;
  name?: string;
  [key: string]: unknown;
}

const sentinelOneLogsCustomColumns = [
  {
    title: "S3 Bucket",
    dataIndex: ["configProperties", "bucketName"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
  {
    title: "Prefix",
    dataIndex: ["configProperties", "prefix"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
  {
    title: "Region",
    dataIndex: ["configProperties", "bucketRegion"],
    render: (v: string) => CellRenderers.VALUE_OR_NA(v),
  },
];

export default function SentinelOneLogsView({
  onUpdateConfigComponent,
  name,
  ...rest
}: SentinelOneLogsViewProps) {
  const s3Tabs: TabConfig[] = useMemo(
    () => [
      {
        key: "aws_s3",
        label: "AWS S3",
        integrationType: SENTINELONE_INTEGRATION_TYPE,
        customColumns: sentinelOneLogsCustomColumns,
      },
    ],
    [],
  );

  return (
    <Tabs
      defaultActiveKey="aws_s3"
      items={[
        {
          key: "aws_s3",
          label: "AWS S3",
          children: (
            <GenericIntegrationView<SentinelOneS3Config>
              tabs={s3Tabs}
              FormComponent={SentinelOneLogsS3ConfigForm}
              onUpdateConfigComponent={onUpdateConfigComponent}
              addButtonText="Add Configuration"
              name={name}
              {...rest}
            />
          ),
        },
        {
          key: "file_upload",
          label: "File Upload",
          children: <SentinelOneLogsFileUpload />,
        },
      ]}
    />
  );
}
